module.exports = __webpack_public_path__ + "static/media/loop-24px.1afff5ff.svg";